import React from "react";
import { Alert, Form, Icon, Input, Button, Row, Col } from "antd";
import { connect } from "react-redux";
import get from "lodash/get";

import { resetPassword, loginTwoFactor } from "../../reducers/user/actions";
import { getUserToken } from "../../reducers/user/selectors";
import { getAccountProfileId } from "../../api/requests";
import { withNamespaces } from "react-i18next";

import classes from "./ResetProfileForm.css";

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some((field) => fieldsError[field]);
}

class UserProfileIdForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      responseMessage: null,
      errorMessage: null,
      isSubmitted: false,
      checkConfirmRequestError: "",
      username: "",
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true });

      if (!err) {
        this.setState({
          isLoading: true,
          errorMessage: null,
          responseMessage: null,
        });

        try {
          const response = await getAccountProfileId(values.password);
          this.props.onSubmit(get(response, "data.user_id"));
        } catch (e) {
          if (get(e, 'response.data.errors')) {
            const errors = {};
            Object.keys(get(e, 'response.data.errors')).forEach(errorFieldKey => {
              errors[errorFieldKey] = {
                value: values[errorFieldKey],
                errors: get(e, `response.data.errors.${errorFieldKey}`).map(errorMessage => new Error(errorMessage))
              }
            });

            console.log(errors);
            this.props.form.setFields(errors);
          }
        }

        this.setState({
          isLoading: false,
        });
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { isLoading } = this.state;

    return (
      <div className={classes.loginForm}>
        <Form onSubmit={this.handleSubmit}>
          <div>
            <Form.Item>
              {getFieldDecorator("password", {
                rules: [{ required: true, message: this.props.i18n.t("Required") }],
              })(
                <Input
                  type="password"
                  prefix={
                    <Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />
                  }
                  placeholder={this.props.i18n.t("Current password")}
                />
              )}
            </Form.Item>
          </div>

          <Row gutter={12}>
            <Col span={12}>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  size="large"
                  className={classes.submitButton}
                >
                  {this.props.i18n.t("Show user ID")}
                  {isLoading && <Icon type="loading" />}
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userToken: getUserToken(state),
});

const mapDispatchToProps = {
  resetPassword,
  loginTwoFactor,
};

export default Form.create({ name: "UserProfileIdForm" })(
  connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(UserProfileIdForm))
);



// WEBPACK FOOTER //
// ./src/components/ResetProfileForm/UserProfileIdForm.js